var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('button',{staticClass:"main-button",class:{
      fullWidth: _vm.isFullWidth,
      halfWidth: _vm.isFullWidth,
      primaryColor: _vm.isPrimaryColor,
      secondaryColor: _vm.isSecondaryColor,
    },style:(_vm.style)},[_vm._v(" "+_vm._s(_vm.label)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }